import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'kts-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})

export class ErrorsComponent implements OnInit {

    constructor(meta: Meta, title: Title) {
        title.setTitle('Error Page | Katiso Engineering and Automation');

        meta.addTags([
            {
                name: 'keywords', content: 'Katiso Engineering, instrumentation, automation, Automotive Supplier, food, beverage, tobacco, packaging, technology, conceptual, final design, manufacture, assembly'
            },
            {

                name: 'description', content: 'Our turnkey solutions & services span a broad range of industries, such as the automotive industries, as well as other industrial sectors. | Katiso Engineering and Automation'
            }
        ])
    }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/errors/errors.component.ts